import { type SupportChatSource, useIntercom } from '~/hooks/useIntercom';

export const useSupportChat = (source: SupportChatSource) => {
  const { openMessenger } = useIntercom();

  const openSupportChat = () => {
    openMessenger(source);
  };

  return { openSupportChat };
};
